module.exports = __webpack_public_path__ + "img/fastcharger-in-progress-private.180a4c65.png";